import type { MenuItem } from '#types/components/cms/mega-menu'
import type { RecursivePartial } from '#types/utils'
import type { InjectionKey, MaybeRefOrGetter } from 'vue'

export interface MegaMenuL2Context {
  /**
   * Featured L2 items are propagated to L3 level and highlight them as well
   */
  featured: boolean
  title: MaybeRefOrGetter<string>
  visualSelectors?: Ref<boolean>
}

export interface MegaMenuL1Context {
  activeL1?: Ref<RecursivePartial<MenuItem>>
  activeL2?: Ref<MenuItem | undefined>
  activeTab?: Ref<number>
  expandedL2?: Ref<string[]>
  l1?: MaybeRefOrGetter<string>
  l2Refs?: Ref<Record<string, HTMLElement | null>>
}

export const MegaMenuL1ContextKey: InjectionKey<MegaMenuL1Context> = Symbol('MegaMenuL1Context')
export const MegaMenuL2ContextKey: InjectionKey<MegaMenuL2Context> = Symbol('MegaMenuL2Context')
export const MegaMenuMobileContextKey: InjectionKey<boolean> = Symbol('MegaMenuMobileContext')
export const MegaMenuVisualSelectorContextKey: InjectionKey<Ref<number> | undefined> = Symbol('MegaMenuVisualSelectorContextKey')
